import React, { useEffect, useState } from 'react';
import { Grid, Tabs, Tab, Box, useMediaQuery } from '@mui/material';
import TeaAndSnacks from '../features/WebView/components/TeaAndSnacks';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast'; // Icon for Tea & Snacks
import AppRegistrationIcon from '@mui/icons-material/AppRegistration'; // Icon for Application
import ApprovalIcon from '@mui/icons-material/Approval'; // Icon for Approval
import PublicIcon from '@mui/icons-material/Public';
import { useAbility } from '@casl/react';
import { AbilityContext } from '../context/Ability';
import DelightsApplication from '../features/Delight/components/DelightsData/DelightsApplication';
import HrDelights from '../features/Delight/HrDelights/HrDelights';
import { useTheme } from '@emotion/react';
import UserPage from '../features/teaAndSnacks/components/UserPage';
import UserPageNew from '../features/teaAndSnacks/components/UserPageNew';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../features/Auth/authSlice';
import { Public } from '@mui/icons-material';

const Delight = () => {
  const [value, setValue] = useState(0);
  const ability = useAbility(AbilityContext);
  const user = useSelector(selectCurrentUser);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // let tabs = [{ label: 'Tea & Snacks', icon: <FreeBreakfastIcon />, component: <TeaAndSnacks /> }];
  let tabs = [
    { label: 'Tea & Snacks', icon: <FreeBreakfastIcon />, component: <UserPageNew event={false} /> },
    { label: 'Event', icon: <FreeBreakfastIcon />, component: <UserPageNew event={true}/> }
  ];

  if (user?.details?.travelData?.userDetails?.isReportingHead) {
    tabs.push({ label: 'Requests', icon: <AppRegistrationIcon />, component: <DelightsApplication /> });
  }

  if (user?.details?.travelData?.userDetails?.isHR) {
    tabs.push({ label: 'Approvals', icon: <ApprovalIcon />, component: <HrDelights /> });
  }

  return (
    <Box
      sx={{
        width: '100%',
        p: 0,
        backgroundColor: 'background.paper',
        // height: '400px',
        // height: 'calc(100vh - 135px)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', border: 0, width: '100%' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Delights tabs"
          variant="fullWidth"
          sx={{
            mt: 1,
            color: 'black',
            backgroundColor: 'background.default',
            border: 0,
            width: '100%',
            // borderColor: 'red',
            borderRadius: 1,
            mb: 0,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            '& .MuiTab-root': {
              color: 'grey',
              minHeight: '48px',
              fontSize: {
                xs: '0.75rem',
                sm: '0.875rem',
                md: '1rem',
                lg: '1rem',
                xl: '1rem',
              },
              px: {
                xs: 1,
                sm: 1,
                md: 1,
              },
            },
            '& .Mui-selected': {
              color: 'black !important',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: 'text.primary',
              height: 2,
            },
            [theme.breakpoints.down('lg')]: {
              border: 0,
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              icon={tab.icon}
              iconPosition="start"
              sx={{
                textTransform: 'none',
                // fontWeight: 'bold',
                fontSize: {
                  xs: '0.75rem',
                  sm: '0.875rem',
                  md: '1rem',
                  lg: '1rem',
                  xl: '1rem',
                },
                px: {
                  xs: 1,
                  sm: 2,
                  md: 3,
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      <Grid container sx={{ height: `calc(100vh - ${isMobile ? '200px' : '150px'})`, border: 0, width: '100%' }}>
        {tabs[value].component && (
          <Grid
            item
            xs={12}
            sm={12}
            display="flex"
            alignItems="start"
            justifyContent="center"
            sx={{
              backgroundColor: 'background.default',
              borderRadius: 1,
              border: 1,
              borderColor: 'divider',
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderTop: 0,
              height: '100%',
              width: '100%',
              p: {
                xs: 1,
                sm: 2,
                md: 3,
                lg: 1,
              },
              [theme.breakpoints.down('lg')]: {
                p: 0,
                border: 0,
                width: '100%',
              },
            }}
          >
            {tabs[value].component}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Delight;
